"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.StyleContext = exports.TypeContext = exports.LevelContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const react_1 = require("react");
const utils_1 = require("../../utils");
exports.LevelContext = react_1.createContext(0);
exports.TypeContext = react_1.createContext('ol');
exports.StyleContext = react_1.createContext({});
// utility function to add props to single and multiple children
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addPropsToChildren = (children) => {
    if (!Array.isArray(children)) {
        return utils_1.addPropsToReactElement(children, { index: 1 });
    }
    return children.map((childElement, index) => utils_1.addPropsToReactElement(childElement, { key: index, index: index + 1 }));
};
const List = ({ children, type, style }) => {
    const level = react_1.useContext(exports.LevelContext);
    const getStyles = () => {
        if (!style)
            return {};
        if (Array.isArray(style)) {
            return style.reduce((pre, curr) => Object.assign(pre, curr), {});
        }
        return style;
    };
    const styles = rpdf_renderer_1.StyleSheet.create({
        list: Object.assign({ marginLeft: `${utils_1.LIST_ITEM_INDENT_WIDTH}pt` }, getStyles()),
    });
    return (jsx_runtime_1.jsx(exports.LevelContext.Provider, Object.assign({ value: level + 1 }, { children: jsx_runtime_1.jsx(exports.TypeContext.Provider, Object.assign({ value: type }, { children: jsx_runtime_1.jsx(exports.StyleContext.Provider, Object.assign({ value: getStyles() }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: styles.list }, { children: addPropsToChildren(children) }), void 0) }), void 0) }), void 0) }), void 0));
};
exports.List = List;
//# sourceMappingURL=list.js.map